module.exports = __webpack_public_path__ + "static/media/testimage.fffdafa1.jpg";